"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgArchive(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M35.637 30.838a1.816 1.816 0 01-1.807 1.636H6.757a1.816 1.816 0 01-1.807-1.636l-1.472-14.76a1.816 1.816 0 011.807-1.996h30.017c1.074 0 1.914.927 1.807 1.996l-1.472 14.76z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M34.816 14.082v-2.343A1.816 1.816 0 0033 9.922H21.043a1.355 1.355 0 01-1.355-1.354v0c0-.748-.606-1.355-1.354-1.355H7.587A1.816 1.816 0 005.771 9.03v5.052", stroke: "currentColor", strokeWidth: 2 }, void 0)] }), void 0));
}
exports.default = SvgArchive;
//# sourceMappingURL=Archive.js.map